export default __webpack_public_path__ + "static/media/culture-min.d5541b14.webp";